import { Component, OnInit } from '@angular/core';
import { VersionService } from './services/version.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  public title = 'ClientApp';
  public version = '';
  public year = new Date().getFullYear();

  constructor(private versionService: VersionService) { }

  public ngOnInit(): void {
    this.versionService.getVersion()
      .subscribe(version => {
        this.version = version;
      });
  }
}
